import React from 'react';
import NavHeaderTop from "./NavHeaderTop";
import NavHeaderBottom from "./NavHeaderBottom";
import './style.scss';

const NavHeader = (props) => {

  return (
    <div id="aps-header" className={`aps__nav-header`}>
      <NavHeaderTop/>
      <NavHeaderBottom/>
    </div>
  );
};

export default NavHeader;
